var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"sword-success-text-wuk"},[_c('sword-icon-wuk',{attrs:{"name":"circle-check"}}),_c('span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }